import { render, staticRenderFns } from "./ReviewTechnology.vue?vue&type=template&id=3e46f55b&scoped=true"
import script from "./ReviewTechnology.vue?vue&type=script&lang=js"
export * from "./ReviewTechnology.vue?vue&type=script&lang=js"
import style0 from "./ReviewTechnology.vue?vue&type=style&index=0&id=3e46f55b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e46f55b",
  null
  
)

export default component.exports